import React from 'react';
import { Tooltip } from 'reactstrap';

const Rect = (props) => {
  function resizeTagText() {
    const elements = document.getElementsByClassName('resize');
    if (elements.length < 0) {
      return;
    }
    for (let _i = 0; _i < elements.length; _i++) {
      const el = elements[_i];
      let newFontSize = parseInt(el.clientHeight / 2);
      if (el.clientWidth < el.clientHeight) {
        newFontSize = parseInt(el.clientWidth / 2);
      }
      if (props.tagFontSize) {
        el.style.fontSize = props.tagFontSize + 'px';
      } else {
        el.style.fontSize = newFontSize + 'px';
      }
    }
  }
  function _resizeTagText() {
    const elements = document.getElementsByClassName('--resize');
    if (elements.length < 0) {
      return;
    }
    for (let _i = 0; _i < elements.length; _i++) {
      const elWrapper = elements[_i];
      const elChildren = elWrapper.firstElementChild;
      // let newFontSize = parseInt(elWrapper.clientHeight / 2);
      // if (elChildren.clientHeight > elWrapper.clientHeight) {
      //   newFontSize = parseInt(elWrapper.clientHeight / 2 - 2);
      // }
      let newFontSize;
      if (props.tagFontSize) {
        elChildren.style.fontSize = props.tagFontSize + 'px';
      } else {
        if (elChildren.clientWidth > elWrapper.clientWidth) {
          newFontSize = parseInt(elWrapper.clientHeight / 2) - 2;
          elChildren.style.fontSize = newFontSize + 'px';
        }
        if (elChildren.clientHeight > elWrapper.clientHeight) {
          newFontSize = parseInt(elWrapper.clientHeight / 2) - 1;
          elChildren.style.fontSize = newFontSize + 'px';
          if (elChildren.clientHeight > elWrapper.clientHeight) {
            newFontSize = parseInt(elWrapper.clientHeight / 3) - 1;
            elChildren.style.fontSize = newFontSize + 'px';
          }
        }
      }
      // console.log(elChildren.style.fontSize);
    }
  }
  React.useEffect(() => {
    // resizeTagText();
    // _resizeTagText();
  });
  const border = `${props.borderSize}px ${props.borderStyle} ${props.borderColor}`;
  let isVertical = true;
  const boxSize =
    props.tagLocation === 'None' ? '100%' : `calc(100% - ${props.tagBoxSize}%)`;
  // - ${props.borderSize * 2}px
  let container = '';
  if (props.tagLocation) {
    switch (props.tagLocation.toLocaleLowerCase()) {
      case 'top':
        container = 'flex-column';
        break;
      case 'right':
        isVertical = false;
        container = 'flex-row-reverse';
        break;
      case 'left':
        isVertical = false;
        container = '';
        break;
      default:
        container = 'flex-column flex-column-reverse';
        break;
    }
  }
  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  return (
    <>
      <Tooltip
        placement="auto"
        isOpen={tooltipOpen}
        target={props.id}
        toggle={toggle}
      >
        {props.sensorName}
      </Tooltip>
      <div
        id={props.id}
        className={`d-flex ${props.tagLocation === 'None' ? '' : container}`}
        style={{
          width: props.w,
          height: props.h,
          top: props.y,
          left: props.x,
          position: 'absolute',
          border: props.borderSize ? border : '1px solid black',
          zIndex: (props.index || 0) + 1,
        }}
      >
        {props.tagLocation !== 'None' ? (
          <div
            className="d-flex align-items-center justify-content-center --resize"
            style={{
              width: isVertical ? props.w : props.tagBoxSize + 'px',
              height: isVertical ? props.tagBoxSize + 'px' : props.h,
              color:
                props.tagTextColor && props.tagTextColor.toLocaleLowerCase(),
              fontSize: props.tagFontSize + 'px',
              fontFamily: props.tagFontName,
              backgroundColor:
                props.tagBackGroundColor &&
                props.tagBackGroundColor.toLocaleLowerCase(),
              overflowY: 'hidden',
              lineHeight: 1,
              wordBreak: 'break-all',
            }}
          >
            <div>{props.tagText}</div>
          </div>
        ) : null}
        {props.value && (
          <div
            className="d-flex justify-content-center align-items-center resize"
            style={{
              width: isVertical ? '100%' : boxSize,
              height: isVertical ? boxSize : props.h,
              backgroundColor: props.fill,
              fontSize: props.valueFontSize + 'px',
              // border: border,
              color: props.valueTextColor && props.valueTextColor.toString(16),
              overflow: 'hidden',
            }}
          >
            {props.value}
          </div>
        )}
      </div>
    </>
  );
};

Rect.defaultProps = {
  w: 1,
  h: 1,
  x: 0,
  y: 0,
  fill: '#007bff',
};
export default Rect;
